import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import styles from './List.module.less'; // <List spacing={...} /> uses this to pass the value of its
// spacing prop down to these disconnected <Li /> components

export var ListSpacingContext = /*#__PURE__*/React.createContext(2); // nested lists add spacing above first <Li /> component

var ListIsNestedContext = /*#__PURE__*/React.createContext(false);
// TODO: in currency v2, we should rename this to ListItem, or (preferably)
// automatically wrap each list child as an item.
export var Li = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      otherProps = _objectWithoutProperties(props, ["children", "className"]);

  var inNestedList = React.useContext(ListIsNestedContext);
  var spacing = React.useContext(ListSpacingContext);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: classNames(className, styles['list-item'], styles["list-item-spacing-".concat(spacing)], !inNestedList && styles['list-item-not-nested'])
  }, otherProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(ListIsNestedContext.Provider, {
    value: true
  }, children));
});
Li.displayName = 'Li';